import { createProductSearchGrid } from './BaseProductSearchGrid.js';
import { createProductConfig } from '@js/algolia/createProductConfig.js';
import { accessoriesConfig } from '@js/config/algolia.js';

function getSpecs(_result) {
  return [];
}

function hasSpecs(_result) {
  return false;
}

function formatCardData(result) {
  return {
    heading: result.title || '',
    url: result.absoluteUri || result.url || '#',
    image: result.productImage || null,
    category:
      result.productType && result.productType.length
        ? result.productType[0]
        : null,
    description: result.description || result.tagline || null,
    truncateDescription: true,
    attributes: [],
    legacy: result.legacy || false,
    controllerSeries: [],
    hideImage: false,
  };
}

export default createProductSearchGrid({
  appId: accessoriesConfig.app_id,
  apiKey: accessoriesConfig.api_key,
  indexName: accessoriesConfig.index,
  configureWidget: createProductConfig('[data-search-accessories]'),
  formatCardData,
  getSpecs,
  hasSpecs,
  scrollToSelector: '[data-search-accessories]',
});
